#import "@/components/common/LinkFragment.gql"

fragment LinkWithImageBlockFragment on linkWithImageBlock_Entry {
  image {
    url
    title
  }
  cta {
    ...LinkFragment
  }
}

fragment LinksDisplayFragment on linksDisplay_Entry {
  typeHandle

  contentSource
  linksDisplayLayout

  # Old Collections Slider data
  heading
  links: collections {
    ...LinkWithImageBlockFragment
  }

  # New Share Data
  sharedLinkCollection {
    ... on linksCollection_Entry {
      heading: title
      links: linkWithImageCollection {
        ...LinkWithImageBlockFragment
      }
    }
  }
}
